<template>
  <div
    class="dropdown-menu"
    :class="{ 'dropdown-menu--hidden': !visible }"
    @contextmenu.prevent
  >
    <div
      class="dropdown-menu__backdrop"
      @click="close"
      @mouseenter="setActiveItem(-1, 0)"
    ></div>
    <div
      class="dropdown-menu__list"
      :class="{
        'dropdown-menu__list--hidden': indent > activeIndent
      }"
      ref="list"
      v-for="(menu, indent) in menus"
      :key="indent"
      :style="menuStyles[indent]"
    >
      <div
        class="dropdown-menu__backdrop"
        @mouseenter="setActiveItem(-1, indent)"
      ></div>
      <div
        class="dropdown-menu__item"
        :class="{
          'dropdown-menu__item--disabled': item.disabled,
          'dropdown-menu__item--active': i === activeItems[indent],
          'dropdown-menu__item--shortcut': !!item.shortcut
        }"
        v-for="(item, i) in menu"
        v-show="!item.hidden"
        :key="i"
        @click="itemClick(i, indent)"
        @mouseenter="setActiveItem(item.disabled ? -1 : i, indent, true)"
      >
        <a-icon
          v-if="item.icon"
          class="dropdown-menu__icon"
          :type="item.icon"
        />
        <svg
          v-if="item.submenu"
          class="dropdown-menu__arrow"
          viewBox="0 0 16 16"
        >
          <path d="M5 1L12 8L5 15L4 14L10 8L4 2z" fill="rgba(0,0,0,.5)" />
        </svg>
        <span v-if="item.shortcut" class="dropdown-menu__shortcut">{{
          item.shortcut
        }}</span>
        {{ item.text }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menus: [],
      menuStyles: [],
      activeItems: [],
      activeIndent: -1
    };
  },
  computed: {
    visible() {
      return this.$store.state.contextMenu.visible;
    },
    contextMenu() {
      return this.$store.state.contextMenu;
    }
  },
  methods: {
    close() {
      this.$store.commit('handleContextMenuClose');
    },
    itemClick(index, indent, activate) {
      const item = this.menus[indent][index];
      if (item && !item.disabled) {
        if (item.submenu) {
          this.openSubmenu(index, indent, activate);
        } else {
          if (item.action) {
            item.action();
          }
          this.close();
        }
      }
    },
    openSubmenu(index, indent, activate) {
      if (this.submenuTimeout) {
        clearTimeout(this.submenuTimeout);
        this.submenuTimeout = null;
      }
      const item = this.menus[indent][index];
      if (item && item.submenu) {
        const listEl = this.$refs.list[indent];
        const itemEl = listEl.querySelectorAll('.dropdown-menu__item')[index];
        const itembcr = itemEl.getBoundingClientRect();

        this.menus = this.menus.slice(0, indent + 1).concat([item.submenu]);
        this.$nextTick(() => {
          let top = itembcr.top - 5;
          let left = itembcr.left + itembcr.width - 1;
          let transformOrigin = 'top';
          const listEl = this.$refs.list[indent + 1];
          if (listEl) {
            if (left + listEl.offsetWidth > window.innerWidth) {
              left = Math.max(itembcr.left - listEl.offsetWidth + 1, 0);
            }
            if (top + listEl.offsetHeight > window.innerHeight) {
              top = Math.max(itembcr.bottom - listEl.offsetHeight + 5, 0);
              transformOrigin = 'bottom';
            }
          }
          this.menuStyles = this.menuStyles.slice(0, indent + 1).concat({
            top: top + 'px',
            left: left + 'px',
            transformOrigin
          });
          this.activeItems = this.activeItems.slice(0, indent).concat(index, activate ? 0 : -1);
          this.activeIndent = indent + 1;
        });
      }
    },
    closeSubmenu(indent) {
      this.activeIndent = indent;
      if (!this.submenuTimeout) {
        this.submenuTimeout = setTimeout(() => {
          this.submenuTimeout = null;
          this.menus = this.menus.slice(0, indent + 1);
        }, 150);
      }
    },
    handleKeyDown(e) {
      if (this.visible) {
        switch (e.keyCode) {
          case 13:
            {
              e.preventDefault();
              this.itemClick(this.activeItems[this.activeItems.length - 1], this.activeItems.length - 1, true);
            }
            break;
          case 37:
            {
              e.preventDefault();
              const indent = Math.max(this.activeIndent - 1, 0);
              this.closeSubmenu(indent);
              this.activeItems = this.activeItems.slice(0, indent + 1);
            }
            break;
          case 39:
            {
              e.preventDefault();
              this.openSubmenu(this.activeItems[this.activeIndent], this.activeIndent, true);
            }
            break;
          case 38:
          case 40:
            {
              e.preventDefault();
              const menuItems = this.menus[this.activeIndent];
              if (menuItems) {
                const offset = e.keyCode === 38 ? menuItems.length - 1 : 1;
                let prevActiveItem = this.activeItems[this.activeIndent];
                let activeMenuItem = (prevActiveItem + offset) % menuItems.length || 0;
                if (e.keyCode === 38 && prevActiveItem === -1) {
                  activeMenuItem = menuItems.length - 1;
                }
                let loop = 0;
                while (menuItems[activeMenuItem].disabled || menuItems[activeMenuItem].hidden) {
                  if (loop >= menuItems.length) {
                    activeMenuItem = -1;
                    break;
                  }
                  loop++;
                  activeMenuItem += offset;
                  activeMenuItem %= menuItems.length;
                }
                this.activeItems = this.activeItems.slice(0, this.menus.length - 1).concat(activeMenuItem);
              }
            }
            break;
        }
      }
    },
    setActiveItem(index, indent) {
      if (this.activeIndent >= indent && this.menus.length) {
        const item = this.menus[indent][index];
        const hasSubmenu = item && item.submenu;
        if (hasSubmenu) {
          this.openSubmenu(index, indent);
        } else {
          this.closeSubmenu(indent);
          this.activeItems = this.activeItems.slice(0, indent).concat(index);
        }
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.menus = [this.contextMenu.items];
        this.activeItems = [-1];
        setTimeout(() => {
          const list = this.$refs.list[0];
          // console.log(list);
          let { x, y } = this.contextMenu;
          let transformOrigin = 'top';
          if (x + list.offsetWidth > window.innerWidth) {
            x = Math.max(window.innerWidth - list.offsetWidth, 0);
          }
          if (y + list.offsetHeight > window.innerHeight) {
            transformOrigin = 'bottom';
            y = Math.max(y - list.offsetHeight, 0);
          }
          this.menuStyles = [{
            top: y + 'px',
            left: x + 'px',
            transformOrigin
          }];
        }, 0);
        setTimeout(() => {
          this.activeIndent = 0;
        }, 50);
      } else {
        this.activeIndent = -1;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>
<style>
.dropdown-menu {
  position: fixed;
  transition: visibility 0.15s;
  z-index: 11;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.dropdown-menu--hidden {
  visibility: hidden;
}

.dropdown-menu__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.dropdown-menu__list {
  position: absolute;
  z-index: 1;
  background: #fff;
  margin: 0;
  padding: 0;
  list-style: none;
  padding: 5px 0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.06);
  line-height: 1.5;
  font-size: 14px;
  transform-origin: center top;
  transition: opacity 0.15s, transform 0.15s;
  border-radius: 2px;
  min-width: 156px;
}

.dropdown-menu__list--hidden {
  transform: rotateX(90deg);
  opacity: 0;
}

.dropdown-menu__item {
  padding: 0.35em 36px;
  cursor: default;
  position: relative;
}

.dropdown-menu__item--active {
  background: rgba(0, 0, 0, 0.08);
}

.dropdown-menu__item--disabled {
  opacity: 0.25;
}

.dropdown-menu__item--shortcut {
  min-width: 176px;
}

.dropdown-menu__arrow {
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 10px;
  width: 12px;
  height: 12px;
}

.dropdown-menu__icon {
  position: absolute;
  top: 50%;
  margin-top: -7px;
  left: 12px;
}

.dropdown-menu__shortcut {
  float: right;
  margin: 0 -4px 0 24px;
}
</style>